import React from "react";
import { Star, Quote } from "lucide-react";
import { Container, Reveal, SectionLabel } from "./primitives";

const TESTIMONIALS = [
  { name: "Marcus Delgado", role: "Owner, Summit Roofing", initials: "MD", color: "#B45309", quote: "WebLaunch delivered a site that looks like a national brand. Our quote requests more than doubled in the first month." },
  { name: "Elena Rossi", role: "GM, Olive Lane Bistro", initials: "ER", color: "#9D174D", quote: "The online reservations and menu are gorgeous and effortless. Our no-shows dropped and bookings are up." },
  { name: "Tom Whitaker", role: "Founder, Greenscape", initials: "TW", color: "#15803D", quote: "The portfolio gallery sells our work before we even pick up the phone. Leads come in every single day now." },
  { name: "Sara Kim", role: "Broker, Harbor View Realty", initials: "SK", color: "#1D4ED8", quote: "Our listings finally look premium. Buyers notice, and our agents look established and credible." },
  { name: "Dr. Amelia Price", role: "Med Spa Director", initials: "AP", color: "#7C3AED", quote: "Online booking transformed our schedule. The team was fast, professional, and a genuine pleasure to work with." },
  { name: "Jordan Blake", role: "Owner, Blake HVAC", initials: "JB", color: "#0F766E", quote: "Clean process, clear communication, and a beautiful result in 72 hours. Worth every penny." },
];

export default function Testimonials({ dark = false }) {
  return (
    <section className={`py-24 ${dark ? "bg-black text-white" : "bg-[#0c0c0d]"}`} data-testid="testimonials-section">
      <Container>
        <div className="max-w-2xl">
          {dark ? <span className="text-xs font-semibold uppercase tracking-widest text-[#E4C96A]">Testimonials</span> : <SectionLabel>Testimonials</SectionLabel>}
          <h2 className={`mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight ${dark ? "text-white" : "text-[#F3EDDC]"}`}>
            Loved by local businesses
          </h2>
          <p className={`mt-3 ${dark ? "text-[#7E7663]" : "text-[#948C79]"}`}>
            Real results from the kinds of businesses we build for every day.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 60}>
              <figure
                data-testid={`testimonial-${i}`}
                className={`h-full rounded-2xl border p-7 transition-transform duration-300 hover:-translate-y-1 ${
                  dark ? "border-white/10 bg-[#141414]/5" : "border-white/10 bg-[#141414] shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
                }`}
              >
                <div className="flex items-center gap-1">
                  {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />)}
                </div>
                <Quote className={`mt-4 h-6 w-6 ${dark ? "text-white/20" : "text-slate-200"}`} />
                <blockquote className={`mt-2 text-[15px] leading-relaxed ${dark ? "text-slate-200" : "text-[#D2CAB2]"}`}>
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-full text-white font-semibold text-sm" style={{ backgroundColor: t.color }}>
                    {t.initials}
                  </span>
                  <span>
                    <span className={`block font-semibold ${dark ? "text-white" : "text-[#F3EDDC]"}`}>{t.name}</span>
                    <span className={`block text-sm ${dark ? "text-[#7E7663]" : "text-[#948C79]"}`}>{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
